import {Api} from '../util';
import _ from 'lodash';

export const setChList = async () => {
    try{
      if(!sessionStorage.getItem('chList')){
        const result = await Api.GetChList({chNo: ''}); 
        const useChList = result.files.ch.filter(ch => ch.use === 'Y');
        const chList = _.keyBy(useChList, 'chName');
        sessionStorage.setItem('chList', JSON.stringify(chList));
      }
      const chListObj = JSON.parse(sessionStorage.getItem('chList'));
      
      this.setState({
        chList: chListObj
      }, () => {
        const initChCondition = _.chain(chListObj).values(chListObj).map(ch=>ch.chId).value();
        this.props.updateSearchCondition(initChCondition);
      });

    } catch(e) {
      console.log(e);
    }
};

export const getChList = () => {
  const chListObj = JSON.parse(sessionStorage.getItem('chList'));
    return chListObj;
};


// WEBPACK FOOTER //
// ./src/util/ChList.js